import dynamic from "next/dynamic";
const GoogleAdSense = dynamic(() => import("./GoogleAdSense"), { ssr: false });
const SheKnowsAd = dynamic(() => import("./SheKnowsAd"), { ssr: false });

const renderAdByNetwork = (adNetwork, adType, adId) => {
  if (adNetwork && adNetwork.toString().toLowerCase() === "adsense") {
    return <GoogleAdSense />;
  } else return <SheKnowsAd type={adType} id={adId} />;
};
const ManualAd = (props) => {
  let { adNetwork, adType, adId } = props;
  return (
    <div className="manualad">
      {renderAdByNetwork(adNetwork, adType, adId)}
      {/* <style jsx>
        {`
          .manualad {
            padding: 15px 0 15px 0;
          }
        `}
      </style> */}
    </div>
  );
};

export default ManualAd;
